import React, { useEffect, useState } from "react";
import { Plus, Pencil, Trash2, RefreshCw, Settings } from "lucide-react";
import api from "../../lib/api";

const ACTION_ICON = { create: Plus, update: Pencil, delete: Trash2, test: RefreshCw };

export default function AdminChangelog() {
  const [log, setLog] = useState([]);
  useEffect(() => { api.get("/admin/changelog?limit=200").then((r) => setLog(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="admin-changelog">
      <h1 className="font-display text-3xl md:text-4xl font-medium text-primary mb-2">Version Log</h1>
      <p className="text-muted-foreground mb-8">A live record of every content and configuration change made in the admin console.</p>

      <div className="relative pl-6 border-l-2 border-primary/10 space-y-6">
        {log.map((l) => {
          const Icon = ACTION_ICON[l.action] || Settings;
          return (
            <div key={l.id} className="relative">
              <span className="absolute -left-[31px] w-6 h-6 rounded-full bg-secondary text-secondary-foreground flex items-center justify-center"><Icon size={12} /></span>
              <div className="bg-card border border-primary/10 rounded-2xl p-4">
                <div className="flex items-center justify-between gap-3 flex-wrap">
                  <p className="font-semibold text-primary">{l.summary}</p>
                  <span className="text-xs text-muted-foreground">{new Date(l.timestamp).toLocaleString()}</span>
                </div>
                <div className="flex items-center gap-3 mt-1 text-xs">
                  <span className="uppercase tracking-wide font-semibold text-secondary">{l.entity}</span>
                  <span className="text-muted-foreground">by {l.user_name || l.user}</span>
                </div>
              </div>
            </div>
          );
        })}
        {log.length === 0 && <p className="text-muted-foreground">No changes recorded yet.</p>}
      </div>
    </div>
  );
}
